import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlingService } from '../general/error-handling.service';
import { keysToLowerCase } from 'src/app/utils/json.util';
import { AppConstants } from 'src/app/app-constants';

@Injectable({
  providedIn: 'root'
})
export class ResultsConversationalService {

  backendUrl:string = environment.backendUrl; 
  promptTypeCustomized: string = AppConstants.SCORE_CUSTOMIZED_PROMPT_TYPE;

  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) {}

  getResultsConversationalData(practiceCallUuid:string): Observable<any> {
    return this.http
      .get<any>(`${this.backendUrl}/results/getConversationalResult?practiceCallUuid=${practiceCallUuid}`)
      .pipe(
        map((result) => result),
        tap((res) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(`conversational results: ${outcome}`);
        }),
        catchError((error) => {
          if (error.status === 500) {
            console.error('Error:', error);
            throw error;
          } else {
            return this.errorHandlingService.handleError<any>(`conversational_results`)(error);
          }
        }),
      );
  }

  getResultsPromptTypeData(practiceCallUuid:string, promptType:string): Observable<any> {
    return this.http
      .get<any>(`${this.backendUrl}/results/practiceCallAnalysis/?practiceCallUuid=${practiceCallUuid}&promptType=${promptType}`)
      .pipe(
        map((result) => {

          // lowercasing and removing whitespaces for Objectives (promptType SCORE_CUSTOMIZED)
          // and the same for every JSON inside the array of Objectives (objectives)
          try {
            if (promptType == this.promptTypeCustomized) {
                if (!result) return result;
                const lowerCaseJson = keysToLowerCase(JSON.parse(result.contentDetails));

                if (
                  'objectives' in lowerCaseJson &&
                  Array.isArray(lowerCaseJson['objectives']) &&
                  lowerCaseJson['objectives'].length > 0
                ) {
                  const objectivesJson = lowerCaseJson.objectives || [];
                  objectivesJson.forEach((objective: any, objectiveIndex: number) => {
                    objectivesJson[objectiveIndex] = keysToLowerCase(objective);
    
                    if (
                      'examples' in objectivesJson[objectiveIndex] &&
                      Array.isArray(objectivesJson[objectiveIndex]['examples']) &&
                      objectivesJson[objectiveIndex]['examples'].length > 0
                    ) {
                      const examplesJson = objectivesJson[objectiveIndex].examples || [];
                      examplesJson.forEach((example: any, exampleIndex: number) => {
                        examplesJson[exampleIndex] = keysToLowerCase(example);
                      });
                      objectivesJson[objectiveIndex].examples = examplesJson;
                    }
                  });
                  lowerCaseJson.objectives = objectivesJson;
    
                  result.contentDetails = JSON.stringify(lowerCaseJson);
                  return result;
                }
                else {
                  return result;
                }
            }
            return result;

          } catch(error) {
            console.error('Error parsing or processing Overall or Customized Results JSON:', error);
            throw error; // Rethrowing the error to be caught by catchError
          }
        }),
        tap((res) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(`prompt type results: ${outcome}`);
        }),
        catchError((error) => {
          if (error.status === 500) {
            console.error('Error:', error);
            throw error;
          } else {
            return this.errorHandlingService.handleError<any>(`conversational_prompt_type_results`)(error);
          }
        }),
      );
  }

  getResultsConversationalTranscript(practiceCallUuid:string): Observable<any> {
    return this.http
      .get<any>(`${this.backendUrl}/results/getUserTranscript?practiceCallUuid=${practiceCallUuid}`)
      .pipe(
        map((result) => result),
        tap((res) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(`conversational results transcript: ${outcome}`);
        }),
        catchError((error) => {
          if (error.status === 500) {
            console.error('Error:', error);
            throw error;
          } else {
            return this.errorHandlingService.handleError<any>(`conversational_results_transcript`)(error);
          }
        }),
      );
  }

}
